import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutaions'

//Statelerimiz
const state = () => ({
    loading: false,
    newAccountNo: null,
    accountId: null,
    status: {},
    zones: [],
    users: [],
    alertDefs: [],
    accountAlertDefs: [],
    notes: [],
    notifications: [],
    hours: [],
    tracings: [],
    accounts: [],
    accountPageInfo: {},
    accountStatus: {},
    communications: [],
    accountDetail: {},
    accountAddress: [],
    accountVacations: [],
    accountCameras: [],
    accountDevices: []
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Account/index.js